import { colors } from '../colors'

export const selectField = {
  backgroundColor: colors.white,
  dropdownBackgroundColor: colors.white,
  boxShadowColor: colors.midGrey,
  hoverBackgroundColor: colors.lightGrey,
  groupItemTextColor: colors.darkGrey,
}
